var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAwardImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 156,
    viewBox: "0 0 149 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4407_12019)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.7452,
    width: 99.7867,
    height: 138.166,
    rx: 15.3518,
    transform: "rotate(7 19.7452 0)",
    fill: "#424460"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.199,
    cy: 28.199,
    r: 7.65185,
    transform: "rotate(7 35.199 28.199)",
    stroke: "#9CABBD",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.199,
    cy: 67.199,
    r: 7.65185,
    transform: "rotate(7 29.199 67.199)",
    stroke: "#9CABBD",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.199,
    cy: 104.199,
    r: 7.65185,
    transform: "rotate(7 25.199 104.199)",
    stroke: "#9CABBD",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7245 20.1914L101.613 26.0714",
    stroke: "#9CABBD",
    strokeWidth: 3.28967,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4701 33.3574L100.21 37.5002",
    stroke: "#9CABBD",
    strokeWidth: 3.28967,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2816 47.4492L88.1427 54.7992",
    stroke: "#9CABBD",
    strokeWidth: 3.28967,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.713 61.0059L96.6019 66.8859",
    stroke: "#9CABBD",
    strokeWidth: 3.28967,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7908 74.0273L95.2655 77.7692",
    stroke: "#9CABBD",
    strokeWidth: 3.28967,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6929 85.6777L93.261 94.0969",
    stroke: "#9CABBD",
    strokeWidth: 3.28967,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2083 104.521L91.3901 109.332",
    stroke: "#9CABBD",
    strokeWidth: 3.28967,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.066 115.92L90.1872 119.127",
    stroke: "#9CABBD",
    strokeWidth: 3.28967,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1943 121.459L88.8509 130.012",
    stroke: "#9CABBD",
    strokeWidth: 3.28967,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.556 123.04C122.235 101.96 122.017 89.3384 123.573 85.6627L108.279 88.7563C105.171 110.471 117.925 125.662 124.691 130.544C121.964 127.558 122.307 118.467 122.82 114.295C120.91 111.851 118.046 108.185 121.865 113.073C125.684 117.961 132.583 121.754 135.556 123.04Z",
    fill: "#5B5E81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3754 137.993C98.6846 130.003 112.757 104.774 117.129 93.1583L102.607 76.4606C95.6879 96.823 75.2205 116.553 65.8516 123.873L84.7454 118.459L77.3754 137.993Z",
    fill: "#767AA5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.095,
    cy: 70.3223,
    r: 21.3829,
    transform: "rotate(7 111.095 70.3223)",
    fill: "#DCE5F3",
    stroke: "#6B7487",
    strokeWidth: 4.38623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.41 60.5036C111.24 58.5635 114.062 58.7987 114.559 60.8493L115.525 64.8417C115.748 65.7599 116.533 66.4326 117.475 66.511L121.546 66.8503C123.675 67.0277 124.32 69.8343 122.482 70.9229L119.082 72.9362C118.252 73.4274 117.841 74.4026 118.068 75.3395L119.001 79.1928C119.5 81.2533 117.075 82.7524 115.455 81.3851L112.258 78.6874C111.545 78.0856 110.529 78.0009 109.726 78.4764L106.127 80.6078C104.303 81.6881 102.16 79.8084 102.993 77.8589L104.551 74.2132C104.93 73.3268 104.686 72.2969 103.949 71.6753L100.929 69.127C99.2966 67.7492 100.397 65.088 102.526 65.2654L106.597 65.6046C107.539 65.6831 108.425 65.1497 108.796 64.281L110.41 60.5036Z",
    fill: "#E08F8B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4407_12019",
    x: 0.661987,
    y: 1.75586,
    width: 138.894,
    height: 153.787,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4407_12019"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4407_12019",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardImage);
export default __webpack_public_path__ + "static/media/award-image.a8b2eb9258e9542ee4cd498d50ebf5f0.svg";
export { ForwardRef as ReactComponent };